export default {
    // document title
    title: '中国篮协技战术平台',
    // base url
    baseUrl: getBaseUrl(),
    // home path
    homePath: '/',
    // login path
    loginPath: '/login',
}

export function getBaseUrl() {
    const envs = {
        DEV: 'http://127.0.0.1:10021',
        TEST: '',
        RELEASE: '',
    }
    return envs['DEV']
}
